import ResetPasswordForm from "../../components/ResetPasswordForm";
import SEOHead from "../../components/SEO/SEOHead";

export default function ResetPassword() {
  return (
    <div>
      <SEOHead
        title="Reset password - Bowling Tournament App"
        description="Choose a new Bowling Tournament App password."
        canonicalUrl="/reset-password"
        noIndex
      />
      <ResetPasswordForm />
    </div>
  );
}
